const BASE_URL = '/api/references';

export default (delegate = []) => ({
  references: [],
  types: [],
  delegates: [],
  ships: [],
  destinations: [],
  seasons: [],
  locale: '',
  currentPage: 1,
  searched: false,
  pages: null,
  loading: false,

  filter() {
    const filter = this.generateFilters();
    if (filter.length >= 0) {
      this.loading = true;
      fetch(
        BASE_URL +
          `?filter[site]=${this.locale}` +
          filter +
          '&page=' +
          this.currentPage
      )
        .then((response) => response.json())
        .then((response) => {
          this.references = response.data;
          this.pages = response.meta;
          this.searched = true;
          this.loading = false;
        });
    } else {
      this.references = [];
      this.searched = false;
      this.currentPage = 1;
    }
  },

  generateFilters() {
    let filters = '';
    filters += this.createFilter('ship', this.ships);
    filters += this.createFilter('destination', this.destinations);
    filters += this.createFilter('season', this.seasons);
    filters += this.createFilter('type', this.types);
    filters += this.createFilter('delegates', this.delegates);

    return filters;
  },

  createFilter(filterName, items) {
    let str = '';
    if (items.length > 0) {
      str = `&filter[${filterName}:in]=`;
      items.forEach((item, index) => {
        str += item;
        if (index < items.length - 1) {
          str += '|';
        }
      });
    }
    return str;
  },

  init() {
    this.locale = document.documentElement.lang;
    this.loading = true;
    if (delegate.length > 0) {
      this.delegates[0] = delegate;
      this.filter();
    } else {
      fetch(BASE_URL + `?filter[site]=${this.locale}`)
        .then((response) => response.json())
        .then((response) => {
          this.references = response.data;
          this.pages = response.meta;
          this.searched = true;
          this.loading = false;
        });
    }
  },
});
